import type { BlogSection } from './blogTypes';

/** Comparison posts carry a Geofleet disclosure and a mid-article Geofleet box. */
export function isComparisonPost(category: string) {
  return /compar/i.test(category);
}

/** Index of the middle H2, where the Geofleet box is inserted; -1 when there are too few headings. */
export function pitchSectionIndex(sections: BlogSection[]) {
  const h2s = sections.flatMap((sec, i) => (sec.type === 'h2' ? [i] : []));
  return h2s.length >= 2 ? h2s[Math.floor(h2s.length / 2)] : -1;
}
